// Utils
import { useProfilesStore } from '@/utils/zustand/providers/profiles-provider';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';
import useSocialProfilesAuthStatus from '@/utils/hooks/swr/useSocialProfilesAuthStatus';

// Components
import { ProfilesList } from '@/components/composite/SelectedProfiles/ProfilesList';
import { GroupProfiles } from '@/components/composite/SelectedProfiles/GroupProfiles';
import { MultiSelectionProfiles } from '@/components/composite/SelectedProfiles/MultiSelectionProfiles';

export type SelectedProfilesProps = {
    itemsSize?: 'base' | 'md';
};

function SelectedProfiles({ itemsSize = 'base' }: SelectedProfilesProps) {
    useSocialProfilesAuthStatus();
    const { activeSocialProfile } = useActiveSocialProfile();
    const { activeSocialProfileId, activeMultiSelectionProfiles, activeGroupId } = useProfilesStore(
        (state) => state
    );

    if (activeMultiSelectionProfiles?.socialProfileIds) {
        return <MultiSelectionProfiles itemsSize={itemsSize} />;
    }

    if (activeGroupId) {
        return <GroupProfiles itemsSize={itemsSize} />;
    }

    if (activeSocialProfileId) {
        return <ProfilesList itemsSize={itemsSize} profiles={[activeSocialProfile]} />;
    }

    return null;
}

export default SelectedProfiles;
